import React, { Component } from "react";
import { compose } from "redux";
import { connect } from "react-redux";
import { withRouter } from "react-router";
import PropTypes from "prop-types";
import { CircularProgress } from "@mui/material";
import { urlResource } from "common/utils";
import client from "common/admin/client";
import ErrorPage from "common/components/ErrorPage";
import AdminOfferReview from "./AdminOfferReview";
import { pick, find } from "lodash";
import { AppValues, TARGET_PREFIXES } from "../../../common/constants";

const updateFields = [
  "short_description",
  "long_description",
  "custom_values",
  "legal",
  "start_at",
  "end_at",
  "target",
  "quantity",
  "offer_template",
  "event_id",
  "building_group_id",
];

class AdminOfferReviewContainer extends Component {
  state = {
    city: null,
    loaded: false,
    offer: null,
    error: null,
    templates: [],
    isHilo: true,
    eventTargets: [],
    groupTargets: [],
  };

  offerUrl = () => {
    const { resource, match } = this.props;
    const { offerId } = match.params;

    return `${resource.plural}/${resource.id}/offers/${offerId}`;
  };

  async componentDidMount() {
    const { resource } = this.props;
    const offerUrl = this.offerUrl();

    try {
      const offer = await client.get(offerUrl);
      const resourceResponse = await client.get(
        `${resource.plural}/${resource.id}`,
      );
      let is_hilo = true;

      if (resourceResponse && resourceResponse?.building_id) {
        const building = !offer.building_id
          ? await client.get(`buildings/${resourceResponse.building_id}`)
          : resourceResponse;
        is_hilo = building.is_hilo;
      }

      const buildingId = offer.building_id || resourceResponse?.building_id;

      if (buildingId) {
        try {
          let eventTargets = [];
          let groupTargets = [];

          if (offer && offer.offer_template === "event") {
            const activeNotifications = await client.get(
              `buildings/${buildingId}/notifications`,
            );
            if (activeNotifications && activeNotifications.length > 0) {
              eventTargets = activeNotifications
                .filter((x) => x.event_id && !x.is_contest)
                .map((notification) => ({
                  value: notification.event_id,
                  label: notification.title,
                }));
            }
          }

          const activeBuildingGroups = await client.get(
            `buildings/${buildingId}/groups`,
          );
          if (
            activeBuildingGroups &&
            activeBuildingGroups.groups &&
            activeBuildingGroups.groups.length > 0
          ) {
            groupTargets = activeBuildingGroups.groups.map((group) => ({
              value: `${TARGET_PREFIXES.group}${group.group_id}`,
              label: group.group_name || group.group_name_fr,
            }));
          }

          this.setState({ eventTargets, groupTargets });
        } catch (error) {
          console.error("Failed to fetch event/group targets:", error);
        }
      }

      const community = await client.get(
        `communities/${resourceResponse.community_id}`,
      );
      const city = await client.get(`cities/${community.city_id}`);

      const templates = await client.get("offer_templates");
      this.setState({ city, templates, offer, loaded: true, isHilo: is_hilo });
    } catch (error) {
      this.setState({ error, loaded: true });
    }
  }

  handleApprove = async () => {
    const offerUrl = this.offerUrl();

    try {
      const offer = await client.post(
        `${offerUrl}/accept_changes`,
        this.state.isHilo === false
          ? { header: AppValues.okktoRequestHeader }
          : undefined,
      );
      this.setState({ offer });
    } catch (error) {
      this.setState({ error });
    }
  };

  handleDelete = async () => {
    const offerUrl = this.offerUrl();
    try {
      await client.del(offerUrl);
      this.props.history.goBack();
    } catch (error) {
      this.setState({ error });
    }
  };

  handleResubmit = async (values) => {
    const { offer } = this.state;
    const offerUrl = this.offerUrl();

    const body = {
      ...pick(values, updateFields),
      legal: values.defaultTerms ? null : values.legal,
      offer_template: values.offer_template.id,
    };

    try {
      if (values.hero) {
        const response = await client.postFile(
          "offers",
          offer.id,
          "hero",
          values.hero,
        );

        body.hero_url = response.url;
      }

      let requesOptions = { body };
      if (this.state.isHilo === false) {
        requesOptions["header"] = AppValues.okktoRequestHeader;
      }
      const updatedOffer = await client.patch(offerUrl, requesOptions);
      this.setState({ offer: updatedOffer });
    } catch (error) {
      this.setState({ error });
    }
  };

  render() {
    const { loaded, error, city, templates, offer, eventTargets, groupTargets } =
      this.state;

    if (!loaded) {
      return <CircularProgress />;
    }

    if (error) {
      return <ErrorPage />;
    }

    const template = find(templates, { id: offer.offer_template });

    return (
      <AdminOfferReview
        offer={offer}
        timezone={city.timezone_name}
        template={template}
        handleApprove={this.handleApprove}
        handleResubmit={this.handleResubmit}
        handleDelete={this.handleDelete}
        eventTargets={eventTargets}
        groupTargets={groupTargets}
      />
    );
  }
}

AdminOfferReviewContainer.propTypes = {
  match: PropTypes.shape({
    path: PropTypes.string.isRequired,
    params: PropTypes.shape({
      offerId: PropTypes.string.isRequired,
    }).isRequired,
  }).isRequired,
  resource: PropTypes.shape({
    id: PropTypes.number.isRequired,
    plural: PropTypes.string.isRequired,
  }).isRequired,
};

const mapStateToProps = (state, { location }) => ({
  resource: urlResource(location.pathname),
});

const enhanced = compose(withRouter, connect(mapStateToProps));

export default enhanced(AdminOfferReviewContainer);
